import './Text.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var text = _7a468({defaultClassName:'_rup8ap0-3-12-1',variantClassNames:{ellipsis:{singleLine:'_rup8ap1-3-12-1',multiLine:'_rup8ap2-3-12-1'}},defaultVariants:{},compoundVariants:[]});